export default __webpack_public_path__ + "static/media/pubg_banner.521cf430.png";